module.exports = __webpack_public_path__ + "static/media/soul_machines_ai.72fc1478.png";